export default __webpack_public_path__ + "static/media/X_logo.ab1bf298.png";